import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "outline";

export function buttonVariants(variant: ButtonVariant = "primary", className?: string) {
  return cn(
    "inline-flex min-h-10 items-center justify-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-cinnabar-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-60",
    variant === "primary" && "bg-cinnabar-600 text-white shadow-soft hover:bg-cinnabar-700",
    variant === "secondary" && "bg-ink text-white hover:bg-black",
    variant === "ghost" && "text-ink hover:bg-white/70",
    variant === "danger" && "bg-red-600 text-white hover:bg-red-700",
    variant === "outline" && "border border-ink/10 bg-white text-ink hover:border-cinnabar-500 hover:text-cinnabar-700",
    className
  );
}

export interface ButtonProps extends ComponentProps<"button"> {
  variant?: ButtonVariant;
}

export function Button({ className, variant = "primary", ...props }: ButtonProps) {
  return <button className={buttonVariants(variant, className)} {...props} />;
}
